import axios from 'axios';
import * as constants from 'constants/index.js';

/**
 * Fetch tracking device location list
 * @param {Object} options
 * @param {string} options.token - bearer token
 * @param {AbortSignal} options.signal - abort signal from AbortController
 * @returns {Promise<Array>} items array
 */
export async function fetchTrackingDevices({ token, signal }) {
  const response = await axios({
    method: 'GET',
    url: `${constants.API_CORE_URL}/tracking/device/location/index`,
    headers: { Authorization: `Bearer ${token}` },
    signal: signal,
  });
  const data = response.data;
  return data?.data?.items || [];
}
